// library imports
import * as React from "react";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useNavStyles } from "../styles/useNavStyles";

// setting imports
import { PrivilegesContext } from "../PrivilegesContext";
import { checkPrivileges } from "../utils/PrivilegesHelper";

// app setting imports
import { AuthenticationContext, NewPatientModalContext } from "../Context";

// helpers imports
import { getHeaders } from "../utils/HeaderHelper";
import NeedHelpModal from "../users/NeedHelpModal";

interface Props {
  role: string;
}

const Nav: React.FC<Props> = (props: any) => {
  // app contexts
  const modalSetting = React.useContext(NewPatientModalContext);
  const authenticationSetting = React.useContext(AuthenticationContext);
  const userPrivileges = React.useContext(PrivilegesContext);

  // states for settings
  const { classes } = useNavStyles();
  const [selected, setSelected] = React.useState<any>("");
  const [assets, setAssets] = React.useState<any>({});
  const [showNeedHelpModal, setShowNeedHelpModal] = React.useState(false);

  const openNeedHelpModal = () => setShowNeedHelpModal(true);
  const closeNeedHelpModal = () => setShowNeedHelpModal(false);

  React.useEffect(() => {
    if (window.location.pathname == "/" || window.location.pathname == "") {
      setSelected("actionQueue");
    } else if (
      window.location.pathname == "/patients" ||
      window.location.pathname.search("/patient_reports") > -1
    ) {
      setSelected("patientList");
    } else if (window.location.pathname == "/patient-lists") {
      setSelected("patientLists");
    } else if (window.location.pathname.includes("/new-patient-list")) {
      setSelected("patientLists");
    } else if (window.location.pathname == "/resource-catalog") {
      setSelected("resource");
    } else if (
      window.location.pathname == "/settings" ||
      window.location.pathname == "/actions-and-programs" ||
      window.location.pathname == "/builder-tools" ||
      window.location.pathname == "/claim-builder" ||
      window.location.pathname == "/claim-template-builder" ||
      window.location.pathname == "/add-claim-template" ||
      window.location.pathname == "/user-administration" ||
      window.location.pathname == "/customer-list" ||
      window.location.pathname == "/login-page-content" ||
      window.location.pathname == "/pricing-tables" ||
      window.location.pathname == "/data-tools" ||
      window.location.pathname == "/providers-and-organizations" ||
      window.location.pathname == "/patient-upload" ||
      window.location.pathname == "/templates-list" ||
      window.location.pathname == "/new-note-template" ||
      window.location.pathname.search("/edit-note-template") > -1 ||
      window.location.pathname == "/ndm-report" ||
      window.location.pathname.search("/ndm-repor") > -1 ||
      window.location.pathname == "/questionnaires-list" ||
      window.location.pathname == "/new-questionnaire" ||
      window.location.pathname.search("/new-questionnaire") > -1 ||
      window.location.pathname == "/reports" ||
      window.location.pathname == "/adt-discharge-report" ||
      window.location.pathname == "/provider-action-report" ||
      window.location.pathname == "/encounter-detail-report" ||
      window.location.pathname == "/immunizaiton-forecast-report" ||
      window.location.pathname == "/vax-aggregate-report" ||
      window.location.pathname == "/patient-demographic-report" ||
      window.location.pathname == "/facilities"
    ) {
      setSelected("adminFunctions");
    } else if (window.location.pathname == "/preferences") {
      setSelected("preferences");
    } else if (window.location.pathname == "/immunization-list") {
      setSelected("immunizations");
    }

    getAssets();
  }, []);

  const getAssets = () => {
    const headers = getHeaders(authenticationSetting.csrfToken);
    // debugger
    fetch(`/data_fetching/navs/assets`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.success == false) {
          console.log(result.message);
        } else {
          setAssets(result.resource);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleNewPatientModalOpen = () => {
    modalSetting.setNewPatientModalOpen(true);
  };

  return (
    <div className="nav-container">
      <div className="nav-link only-for-space"></div>

      {props?.role == "patient" ? (
        <>
          <Link
            href={props.role == "patient" ? "/?menu=false" : "/"}
            className="nav-link"
          >
            {location.pathname == "/" ? (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/home_icon_with_label_active.png"
                className={classes.navIcon2}
                alt="Home Icon"
              />
            ) : (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/home_icon_with_label_inactive.png"
                className={classes.navIcon2}
                alt="Home Icon"
              />
            )}
          </Link>

          <Link href="/sync-device" className="nav-link">
            {location.pathname == "/sync-device" ? (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/my_device_icon_active.png"
                className={classes.navIcon2}
                alt="Sync Device Incon"
              />
            ) : (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/my_device_icon_inactive.png"
                className={classes.navIcon2}
                alt="Sync Device Incon"
              />
            )}
          </Link>

          <Link href="/my-info" className="nav-link">
            {location.pathname == "/my-info" ? (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/my_info_icon_active.png"
                className={classes.navIcon2}
                alt="My Info Icon"
              />
            ) : (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/my_info_icon_inactive.png"
                className={classes.navIcon2}
                alt="My Info Icon"
              />
            )}
          </Link>
          <Link href="/preferences" className="nav-link">
            {location.pathname == "/preferences" ? (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/preferences_icon_active.svg"
                className={classes.navIcon2}
                alt="Preferences Icon"
              />
            ) : (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/preferences_icon_inactive.svg"
                className={classes.navIcon2}
                alt="Preferences Icon"
              />
            )}
          </Link>
          <Link href="/contact-us" className="nav-link">
            {location.pathname == "/contact-us" ? (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/contact_us_icon_active.png"
                className={classes.navIcon2}
                alt="Contact Us Icon"
              />
            ) : (
              <img
                src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/contact_us_icon_inactive.png"
                className={classes.navIcon2}
                alt="Contact Us Icon"
              />
            )}
          </Link>
        </>
      ) : (
        <>
          <Link
            href={props.role == "patient" ? "/?menu=false" : "/"}
            className={`nav-link ${
              selected == "actionQueue" ? "navSelected" : ""
            }`}
            onClick={() => setSelected("actionQueue")}
          >
            <img
              src={assets.nav_queue_icon}
              alt="QueueIcon"
              className={"down-10px pad-10px"}
              id="actionQueue"
            />
          </Link>
          <RouterLink
            to="/patients"
            className={`nav-link ${
              selected == "patientList" ? "navSelected" : ""
            }`}
            onClick={() => setSelected("patientList")}
          >
            <img
              src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/nav_patients_icon.png"
              alt="PatientsIcon"
              className={"down-10px pad-10px"}
              id="patientList"
            />
          </RouterLink>
          <RouterLink
            to="/patient-lists"
            className={`nav-link ${
              selected == "patientLists" ? "navSelected" : ""
            }`}
            onClick={() => setSelected("patientLists")}
          >
            <img
              src={assets.nav_patient_lists_icon}
              alt="PatientListsIcon"
              className={"down-10px"}
              style={{ padding: "1px" }}
              id="patientLists"
            />
          </RouterLink>
          <Link
            href="https://hie.ndhin.com/concerto/Login.htm"
            target="_blank"
            className="nav-link"
          >
            <img
              src={assets.nav_hie_icon}
              alt="ChatIcon"
              className="down-10px pad-10px"
            />
          </Link>
          {checkPrivileges(userPrivileges, "Invite New Patient") && (
            <Link
              onClick={handleNewPatientModalOpen}
              className={`nav-link ${
                selected == "addPatient" ? "navSelected" : ""
              }`}
            >
              <img
                src={assets.nav_add_patient_icon}
                alt="Add Patient"
                className={"down-10px pad-10px"}
                id="addPatient"
              />
            </Link>
          )}
          <RouterLink
            to="/immunization-list"
            className={`nav-link ${
              selected == "immunizations" ? "navSelected" : ""
            }`}
            onClick={() => setSelected("immunizations")}
          >
            <img
              src="https://starfield-static-assets.s3.us-east-2.amazonaws.com/vaccinationIcon.svg"
              alt="ResourceCatalogIcon"
              className={"down-10px pad-10px"}
              id="resource"
            />
          </RouterLink>
          <RouterLink
            to="/settings"
            className={`nav-link ${
              selected == "adminFunctions" ? "navSelected" : ""
            }`}
            onClick={() => setSelected("adminFunctions")}
          >
            <img
              src={assets.nav_settings_icon}
              alt="SettingsIcons"
              className={"down-10px pad-10px"}
              id="adminFunctions"
            />
          </RouterLink>
          <RouterLink className="nav-link" onClick={openNeedHelpModal}>
            <img
              src={assets.nav_need_help_icon}
              alt="Need help icon"
              className={"down-10px pad-10px"}
              id="needHelp"
            />
          </RouterLink>
          <div className="ending-padding"></div>

          {openNeedHelpModal && (
            <NeedHelpModal
              showNeedHelpModal={showNeedHelpModal}
              closeNeedHelpModal={closeNeedHelpModal}
            />
          )}
        </>
      )}
    </div>
  );
};

export default Nav;
